import { BillingCycle, Service } from '.';

export enum AddOnType {
  TeamMember = 'user',
  CustomDomain = 'landing_page_domains',
  LimitGreetRollUp = 'limit_greet_roll_up',
}

export interface AddOn {
  type: AddOnType;
  quantity: number;
  price: number;
  interval: BillingCycle;
  uuid: string;
  cancelled?: boolean;
  cancelled_days_left?: number;
  cancelled_days_left_text?: string;
}

export interface AddOnPriceItem {
  name: string;
  amount: number;
  interval: BillingCycle;
  is_active: boolean;
}

export interface AddOnPrice {
  type: AddOnType;
  addons: AddOnPriceItem[];
}

export interface AddOnCheckoutDetails {
  type: AddOnType;
  addon_price: number;
  billing_description: string;
  billing_cycle: BillingCycle;
  billing_date: string;
  total_bill: number;
}

export interface AddOnItem {
  type: AddOnType;
  icon: string;
  label: string;
  price: number;
  billingInfo: string;
  tooltipText: string;
  uuid: string;
  cycle?: string;
  interval?: BillingCycle;
  quantity?: number;
  description?: string;
  service?: Service;
  cancelled?: boolean;
  cancelledText?: string;
}
